import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { useConfig } from "../../hooks/use-config";

import { LazyEmailVerifier } from "../../components/emailverifier"
import * as Constants from "../../helpers/constants"

const StyledContainer = styled(Container)`
  .highlighter {
    display: inline-block;
    text-decoration: none;
    position: relative;
  }

  .try-other-services a {
    background: linear-gradient(0deg, #fffcfc63, #101111) no-repeat right bottom / 0 var(--bg-h);
    transition: background-size 350ms;
    --bg-h: 100%;
  }

  .try-other-services a:where(:hover, :focus-visible) {
    background-size: 100% var(--bg-h);
    background-position-x: left;
  }

  .try-other-services .underline {
    padding-bottom: 2px;
    --bg-h: 2px;
  }

  .highlighter::before {
    content: '';
    background-color: #ffc1076e;
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 5px;
    transition: all .3s ease-in-out;
  }

  .trust-business-logos {
    border: 0px solid rgb(75, 70, 74);
    display: flex;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
  }

  .trust-business-logos>div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .trust-business-logos>* {
    flex: 1 1 200px;
    padding: 10px;
  }

  .container-block {
      max-width: 75% !important;
  }

  h2{
    color: #3d3a3a !important;
  }

  .try-it-now {
    display: flex;
    justify-content: center;
    background-color: rgb(233 234 235 / 70%);
    border-radius: 20px 20px 0px 0px;
  }

  @media (max-width: 991px) {
    .container-block {
      max-width: 100% !important;
    }

    .try-it-now {
      max-width: 100% !important;
      padding: 0px !important;
      border-radius: 0px !important;
      margin: 0px;
      background-color: #f5f5f582;
    }
  }

`

const TrustedByBusinesses = () => {
  const { googleReCaptcha: googleReCaptchaConfig } = useConfig();
  return (
    <StyledContainer className="pt-4">
      <div className="d-flex justify-content-center text-center trust-business pb-4">
        <div className="container-block">
          <h2 className="fw-bold pb-3">Trusted By Businesses of All Sizes Worldwide</h2>
          <p className="lh-base our-sol">Our solutions have been adopted by <span className="badge bg-secondary lh-l1">{Constants.NUMBER_OF_BUSSINESS_TRUST_CO}</span> businesses worldwide to efficiently identify and qualify leads in real-time and in bulk.</p>
        </div>
      </div>
      <div className="d-flex trust-business-logos justify-content-center pb-4">
        <div className="logo">
          <StaticImage
            src="../../images/logos/adobe.png"
            alt="Adobe"
            layout="fixed"
            placeholder="blurred"
            width={138}
            height={37}
          />
        </div>
        <div className="logo">
          <StaticImage
            src="../../images/logos/truecaller.png"
            alt="Truecaller"
            layout="fixed"
            placeholder="blurred"
            width={160}
            height={40}
          />
        </div>
        <div className="logo">
          <StaticImage
            src="../../images/logos/chargebee.png"
            alt="chargebee"
            layout="fixed"
            placeholder="blurred"
            width={160}
            height={47}
          />
        </div>
        <div className="logo">          
          <StaticImage
            src="../../images/logos/datacaptive.png"
            alt="DataCaptive"
            layout="fixed"
            placeholder="blurred"
            width={170}
            height={40}
          />
        </div>
        <div className="logo">          
          <StaticImage
            src="../../images/logos/inmobi.png"
            alt="InMobi"
            layout="fixed"
            placeholder="blurred"
            width={160}
            height={23}
          />
        </div>
        <div id="giveashot" />
      </div>
      <div className="row try-it-now pt-3" >
      
        <div className="d-flex justify-content-center pt-3 pb-3">
          <h3 className="text-center fw-normal">
            You'll Never Know Unless You&nbsp;
            <Link to="/email-verifier" className="highlighter">
              Try Email Verifier!
            </Link>
          </h3>
        </div>
        <LazyEmailVerifier placeholder="test@example.com" reCaptchaKey={googleReCaptchaConfig.site_key} scrollPosY={50} />
        <p className="try-other-services text-center mt-3 mb-3">
          <Link className="text-secondary underline" to="/email-finder">
            Try Email Finder
          </Link>
          &nbsp;|&nbsp;
          <Link className="text-secondary underline" to="/sales-prospecting">
            Try Prospect Finder
          </Link>
        </p>

      </div>
    </StyledContainer>
  )
}

export default TrustedByBusinesses;